import RolesComponent from 'components/roles/RolesComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import roles from 'data/roles';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type RolesPageProps = WithBaseUrl;

const RolesPage: React.FC<RolesPageProps> = ({ baseUrl }) => {
  const { t } = useI18n('roles');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        url={APP_URLS.roles}
        title={t('page-title')}
        desc={t('page-description')}
        imgUrl={`${baseUrl}${getPublicPath('/images/cards/card_roles.png')}`}
        indexable={true}
      />
      <RolesComponent roles={roles} />
    </>
  );
};

export default RolesPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'roles'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
